import React from 'react';
import './Footer.css';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-content">
                <div className="footer-left">
                    <p className="footer-text">Anjuman-e-Burhani</p>
                    <p className="footer-text">Austin</p>
                    <p className="footer-text">13209 Old Gregg Ln, Pflugerville</p>
                </div>
                <div className="footer-right">
                    <div className="footer-right-content">
                        <div className="footer-spacer"></div>
                        <p className="footer-copyright">Copyright @ KapsLok</p>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer; 